// Version : 0.0.1
// Author : AGALYA
// LastEdit : SATHISH
// LastAdd : chanegs for code review correction
// MODFIED DATE:06-11-2025

import WorkFlowManagementActionTypes from './work-flow-management.types';

/** ***************** GET ALL_ROLE DETAILS START *********************** */
export const getAllRoleDetailsStart = (getData: any) => ({
	type: WorkFlowManagementActionTypes.GET_ALL_ROLE_LIST_START,
	payload: getData,
});

export const getAllRoleDetailsSuccess = (successData: any) => ({
	type: WorkFlowManagementActionTypes.GET_ALL_ROLE_LIST_SUCCESS,
	payload: successData,
});

export const getAllRoleDetailsFailure = (failureData: any) => ({
	type: WorkFlowManagementActionTypes.GET_ALL_ROLE_LIST_FAILURE,
	payload: failureData,
});

export const getAllRoleDetailsResponseResetStart = () => ({
	type: WorkFlowManagementActionTypes.GET_ALL_ROLE_LIST_RESPONSE_RESET,
});

export const getAllRoleDetailsResponseChanged = () => ({
	type: WorkFlowManagementActionTypes.GET_ALL_ROLE_LIST_RESPONSE_CHANGED,
});

/** ***************** GET ALL_ROLE DETAILS END *********************** */

/** ***************** ADD CREDIT APPRAISAL DETAILS START *********************** */
export const addCreditAppraisalDetailsStart = (addData: any) => ({
	type: WorkFlowManagementActionTypes.ADD_CREDIT_APPRAISAL_DETAILS_START,
	payload: addData,
});

export const addCreditAppraisalDetailsSuccess = (successData: any) => ({
	type: WorkFlowManagementActionTypes.ADD_CREDIT_APPRAISAL_DETAILS_SUCCESS,
	payload: successData,
});

export const addCreditAppraisalDetailsFailure = (failureData: any) => ({
	type: WorkFlowManagementActionTypes.ADD_CREDIT_APPRAISAL_DETAILS_FAILURE,
	payload: failureData,
});

export const addCreditAppraisalDetailsResponseResetStart = () => ({
	type: WorkFlowManagementActionTypes.ADD_CREDIT_APPRAISAL_DETAILS_RESPONSE_RESET,
});

export const addCreditAppraisalDetailsResponseChanged = () => ({
	type: WorkFlowManagementActionTypes.ADD_CREDIT_APPRAISAL_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD CREDIT APPRAISAL DETAILS END *********************** */

/** ***************** GET ALL_CREDIT_APPRAISAL DETAILS START *********************** */
export const getAllCreditAppraisalDetailsStart = (getData: any) => ({
	type: WorkFlowManagementActionTypes.GET_ALL_CREDIT_APPRAISAL_LIST_START,
	payload: getData,
});

export const getAllCreditAppraisalDetailsSuccess = (successData: any) => ({
	type: WorkFlowManagementActionTypes.GET_ALL_CREDIT_APPRAISAL_LIST_SUCCESS,
	payload: successData,
});

export const getAllCreditAppraisalDetailsFailure = (failureData: any) => ({
	type: WorkFlowManagementActionTypes.GET_ALL_CREDIT_APPRAISAL_LIST_FAILURE,
	payload: failureData,
});

export const getAllCreditAppraisalDetailsResponseResetStart = () => ({
	type: WorkFlowManagementActionTypes.GET_ALL_CREDIT_APPRAISAL_LIST_RESPONSE_RESET,
});

export const getAllCreditAppraisalDetailsResponseChanged = () => ({
	type: WorkFlowManagementActionTypes.GET_ALL_CREDIT_APPRAISAL_LIST_RESPONSE_CHANGED,
});

/** ***************** GET ALL_CREDIT_APPRAISAL DETAILS END *********************** */

/** ***************** DELETE CREDIT APPRAISAL DETAILS START *********************** */
export const deleteCreditAppraisalDetailsStart = (deleteData: any) => ({
	type: WorkFlowManagementActionTypes.DELETE_CREDIT_APPRAISAL_DETAILS_START,
	payload: deleteData,
});

export const deleteCreditAppraisalDetailsSuccess = (successData: any) => ({
	type: WorkFlowManagementActionTypes.DELETE_CREDIT_APPRAISAL_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteCreditAppraisalDetailsFailure = (failureData: any) => ({
	type: WorkFlowManagementActionTypes.DELETE_CREDIT_APPRAISAL_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteCreditAppraisalDetailsResponseResetStart = () => ({
	type: WorkFlowManagementActionTypes.DELETE_CREDIT_APPRAISAL_DETAILS_RESPONSE_RESET,
});

export const deleteCreditAppraisalDetailsResponseChanged = () => ({
	type: WorkFlowManagementActionTypes.DELETE_CREDIT_APPRAISAL_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE CREDIT APPRAISAL DETAILS END *********************** */
